import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ExtractEventRequest, ExtractEventResponse } from './extractEvent.types';
import { extractEvent } from './extractEvent.api';

export function useExtractEvent() {
  return useMutation<ExtractEventResponse, AxiosError, ExtractEventRequest>({
    mutationFn: extractEvent
  });
}
